<template>
  <div v-if="!busy">
    <div class="pa-3 d-flex">
      <v-btn class="btn-white" to="/farm/flowers">{{ $t("back") }}</v-btn>
      <div class="ml-auto d-flex">
        <v-btn class="grey" style="width: 100px" to="/farm/flowers">{{ $t("cancel") }}</v-btn>
        <v-btn
          v-if="flower_id && !edit"
          class="green ml-2"
          style="width: 100px"
          @click="editHandler"
        >{{ $t("edit_product") }}</v-btn>
        <v-btn
          v-else-if="flower_id && edit"
          class="orange ml-2"
          style="width: 100px"
          @click="save"
        >{{ $t("save_changes") }}</v-btn>
        <v-btn v-else class="green ml-2" style="width: 100px" @click="save">{{ $t("add_product") }}</v-btn>
      </div>
    </div>
    <v-card class="mx-3 pa-3" style="overflow: scroll" flat>
      <table class="detail-table">
        <tbody>
          <tr>
            <td>
              <tooltip-error :open="error.imgs" content="image" />
            </td>
            <td>
              <img-handler direct :default-value="imgs" @finish="imageHandler" multi-preview :is-edit="!(flower_id && !edit)"/>
            </td>
          </tr>
          <tr v-if="!flower_id">
            <td>{{ $t("category_name") }}</td>
            <td>
              <category :category-id="content.categoryId" @select="categoryHandler" :read-only="!!flower_id"></category>
            </td>
          </tr>

          <tr>
            <td>{{ $t("genus_name") }}</td>
            <td>
              <genus :genus-id="content.genusId" :category-id="content.categoryId" @select="genusHandler" :read-only="!!flower_id"></genus>
            </td>
          </tr>

          <tr>
            <td>
              <tooltip-error :open="error.specieId" content="flower_specie" />
            </td>
            <td>
              <specie
                :genus-id="content.genusId"
                :specie-id="content.specieId"
                :read-only="!!flower_id"
                @select="id=>content.specieId = id"
              ></specie>
            </td>
          </tr>

        </tbody>
      </table>
    </v-card>

  </div>
</template>

<script>
import Category from "@/components/farm/flowers/category/index.vue";
import Genus from "@/components/farm/flowers/genus/index.vue";
import Specie from "@/components/farm/flowers/specie/index.vue";
import ImgHandler from "@/components/shared/ImgHandler/index.vue";
import TooltipError from "@/components/shared/TooltipError.vue";

export default {
  components: {
    Category,
    Genus,
    Specie,
    ImgHandler,
    TooltipError
  },
  data() {
    return {
      flower_id: null,
      imgs: [],
      content: {
        categoryId: null,
        genusId: null,
        specieId: null
      },
      genusDialog: false,
      specieDialog: false,
      invalid: null,
      error: {},
      busy: false,
      edit: false,
      editContent: {}
    };
  },
  async created() {
    this.flower_id = this.$route.params.flower_id;
    this.busy = true;

    if (this.flower_id) {
      await this.$store.dispatch("flowers/getFlowers", [this.flower_id]);

      const flower = this.$store.state.flowers.list[this.flower_id];

      this.img = flower.image_url;
      this.imgs = flower.images;
      this.content.specieId = flower.flower_specie.id;
      this.content.genusId = flower.flower_specie.flower_genus.id;

      await this.$store.dispatch("flowerSpecie/getFlowerSpecie", this.content.genusId);
      await this.$store.dispatch("flowerGenus/getFlowerGenus");
    }

    await this.$store.dispatch("Category/getCategories");
    this.busy = false;
  },
  methods: {
    categoryHandler(categoryId, keepSelectedGenus) {
      this.content.categoryId = categoryId;

      if (!keepSelectedGenus) {
        this.content.genusId = null;
      }

      if (categoryId) {
        this.$store.dispatch("flowerGenus/getFlowerGenusFromCategory", categoryId);
      }
    },
    genusHandler(genusId, keepSelectedSpecie) {
      this.content.genusId = genusId;

      if (!keepSelectedSpecie) {
        this.content.specieId = null;
      }

      if (genusId) {
        this.$store.dispatch("flowerSpecie/getFlowerSpecie", genusId);
      }
    },
    imageHandler(e) {
      switch (e) {
        case "OVERSIZE":
          this.$store.dispatch("setSnackBar", { msg: this.$t("image_size_over"), color: "red" }, { root: true });
          this.$store.dispatch("snackOn", {}, { root: true });
          break;

        case "WRONG_FORMAT":
          this.$store.dispatch("setSnackBar", { msg: this.$t("image_wrong_format"), color: "red" }, { root: true });
          this.$store.dispatch("snackOn", {}, { root: true });
          break;

        default:
          this.content.imgs = e;
          this.$store.dispatch("flowerSpecie/setNewImage", e[0]);
          break;
      }
    },

    async save() {
      console.log(this.data);
      // Get only modified items from content.
      if (this.flower_id) {
        if (this.hasError(true)) return;

        if (Object.keys(this.content).length) {
          await this.$store.dispatch("flowers/putFlower", {
            flower_id: this.flower_id,
            data: this.content
          });
          this.$store.dispatch("flowerSpecie/setNewImage", null);
          this.edit = false;
        }
      } else {
        if (this.hasError()) return;

        if (this.$store.getters["flowerSpecie/isCreatedWithoutImage"]) {
          this.$store.dispatch("flowerSpecie/putFlowerSpecie", {
            specieId: this.content.specieId,
            data: {
              data: this.content.imgs[0].image_url
            }
          });
          this.$store.dispatch("flowerSpecie/setIsCreatedWithoutImage", false);
        }
        const id = await this.$store.dispatch(
          "flowers/postFlower",
          this.content
        );

        if (id) {
          this.$store.dispatch("flowerSpecie/setNewImage", null);
          delete this.content.genusId;
          this.$router.push("/farm/flowers");
        }
      }
    },
    editHandler() {
      if (!this.edit) {
        this.edit = true;
      } else if (Object.keys(this.editContent).length) {
        this.$store
          .dispatch("flowers/putFlowers", this.editContent)
          .then(() => {
            this.editContent = {};
            this.edit = false;
            this.createTableData();
          });
      } else {
        this.edit = false;
      }
    },
    hasError(ignoreImg) {
      this.invalid = false;
      this.error = {};

      const arr = [
        "imgs",
        "specieId",
      ];

      for (let i = 0; i < arr.length; i++) {
        const x = arr[i];
        if (ignoreImg && x === "imgs") {
          continue;
        }

        if (!this.content[x]) {
          this.invalid = x;
          this.error[x] = true;
          return true;
        }
      }

      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 600px) {
  .detail-table {
    width: 100%;
    & td:nth-child(1) {
      width: 100px;
    }
  }
}

.detail-table {
  border-collapse: collapse;
  table-layout: fixed;

  & td {
    width: 400px;
    background: white;
    border-bottom: 1px solid #cccccc;
    padding: 20px 5px 20px 5px;
  }

  & td:nth-child(1) {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 1.1rem;
  }

  & tr:nth-last-child(1) td {
    border: none;
  }
}

.flower-invalid {
  color: red;
}

.t1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail-select {
  height: 60px;
}
</style>
